namespace Riepiloghi.Administration {
    export interface RolePermissionListResponse extends Serenity.ListResponse<string> {
    }
}

